import {BijbError} from '../../models/bijb-error';
import {ModuleSubscription} from '../../models/module-subscription';
import {LoadableState} from './loadable-state';
import {autoserializeAs, inheritSerialization} from 'cerialize';

@inheritSerialization(LoadableState)
export class ModuleSubscriptionsState extends LoadableState {
  public static readonly key = 'ModuleSubscriptionsState';

  @autoserializeAs(ModuleSubscription, 'moduleSubscriptions')
  public moduleSubscriptions: ModuleSubscription[] = [];

  @autoserializeAs(BijbError, 'error')
  public error: BijbError = null;
}
